"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ColorLibController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ColorLibController"));
class CategoryItem {
    constructor(data, active) {
        this.colorLibController = new ColorLibController_1.default();
        this.category = data.category || '-';
        this.count = data.count || -1;
        this.gis_areas = data.gis_areas || [];
        this.active = active || false;
    }
    getCategory() {
        return this.category;
    }
    getCount() {
        return this.count;
    }
    isActive() {
        return this.active;
    }
    getGisAreas() {
        return this.gis_areas;
    }
    getCategoryTitle() {
        return this.colorLibController.getCategoryTitle(this.category);
    }
    getAlphaCategory() {
        return this.colorLibController.getAlphaCategory(this.category);
    }
    getClassCategory() {
        if (this.active) {
            return [
                'category-card-filter__active',
                `bmfw-background-color-bmk_certificate_${this.getAlphaCategory().toLowerCase()}`,
                `bmfw-color-bmk_certificate_${this.getAlphaCategory().toLowerCase()}_darkest`,
            ];
        }
        else {
            return [
                'category-card-filter__disabled',
                `bmfw-border-color-bmk_certificate_${this.getAlphaCategory().toLowerCase()}`,
                `bmfw-color-bmk_certificate_${this.getAlphaCategory().toLowerCase()}`,
            ];
        }
    }
    getAllCrops() {
        const uniqueCrops = [];
        this.getGisAreas().forEach((gisArea) => {
            uniqueCrops.push(gisArea.crop);
        });
        const distinctCrops = Array.from(uniqueCrops);
        return distinctCrops;
    }
    getAllCropsWithCount() {
        const cropCountMap = new Map();
        this.getGisAreas().forEach((item) => {
            const cropId = item.crop.id;
            const crop = item.crop;
            if (!cropCountMap.has(cropId)) {
                cropCountMap.set(cropId, { crop, count: 1 });
            }
            else {
                const existingCropCount = cropCountMap.get(cropId);
                existingCropCount.count++;
            }
        });
        return Array.from(cropCountMap.values());
    }
    filterGisAreasByCropId(cropId) {
        const gisAreasByCrop = this.getGisAreas().filter((gisArea) => {
            return gisArea.crop.id === cropId;
        });
        this.gis_areas = gisAreasByCrop;
        return gisAreasByCrop;
    }
    filterGisAreasByParam(param) {
        if (param.length > 0) {
            this.gis_areas = this.gis_areas
                .filter((area) => area.areaName.toLowerCase().includes(param.toLowerCase()) ||
                area.category.toLowerCase().includes(param.toLowerCase()) ||
                area.crop.crop_name.toLowerCase().includes(param.toLowerCase()) ||
                area.gis_area_id.toString().includes(param))
                .map((sam) => sam);
        }
        return this.gis_areas;
    }
}
exports.default = CategoryItem;
